import { FC, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import styles from 'components/features/coaching/advisorLandingPage/AdvisorLandingPage/AdvisorLandingPage.styl'
import ExternalLayout from 'components/features/external/ExternalLayout/ExternalLayout'
import TopCoachesSection from 'components/features/coaching/advisorLandingPage/TopCoachesSection/TopCoachesSection'
import IncomeSection from 'components/features/coaching/advisorLandingPage/IncomeSection/IncomeSection'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import PressSection from 'components/features/pfm/HomePage/PressSection'
import { HeroSection } from 'components/features/coaching/advisorLandingPage/HeroSection/HeroSection'
import { HowitworksCoachSection } from 'components/features/coaching/advisorLandingPage/HowitworksCoachSection/HowitworksCoachSection'
import ReviewsSection from 'components/features/coaching/advisorLandingPage/ReviewsSection/ReviewsSection'
import SecuritySection from 'components/features/pfm/HomePage/SecuritySection'
import { OverviewCoachSection } from 'components/features/coaching/advisorLandingPage/OverviewCoachSection/OverviewCoachSection'
import { PageAnchorHandler } from 'handlers/PageAnchorHandler/PageAnchorHandler'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'

type AdvisorLandingPageProps = {}

export const AdvisorLandingPage: FC<AdvisorLandingPageProps> = () => {

  const dispatch = useStoreDispatch()
  const handleCta = useCallback((income?: number) => {
    dispatch(modifyFloatingPaneActionCreator('advisor', {
      mode: 'request',
      step: 'topic',
      fields: {
        flow: 'landing',
        income,
      },
    }))
  }, [dispatch])

  return (
    <div className={ styles.AdvisorLandingPage }>
      <PageAnchorHandler placement='coaching' />
      <PageMeta
        title='Financial Coaching | Video Chat with Top Advisors | Status Money'
        description='Video chat with a financial advisor. Get financial advice from the community for free.'
      />
      <div className={ styles.pageContent }>
        <ExternalLayout type='homepage'>
          <HeroSection onCTA={ handleCta } />
          <PressSection />
          <HowitworksCoachSection onCTA={ handleCta } />
          <TopCoachesSection />
          <ReviewsSection />
          <OverviewCoachSection />
          <SecuritySection />
          <IncomeSection onCTA={ handleCta } />
        </ExternalLayout>
      </div>
    </div>
  )
}
